module.exports = __webpack_public_path__ + "media/question9_au.5d046bc3.mp3";